export default __webpack_public_path__ + "static/media/circleGreen.cb3438af.gif";